import React, { useEffect, useState, useRef } from 'react';

import { Container, Grid, Typography } from '@mui/material';

import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import { ThemeClient } from '../contexts/Theme'
import { useCompany } from '../contexts/Company';

import Navbar from '../Navbar'

import { useParams } from "react-router-dom";

import Activities from '../components/session/activities/Activities';
import CardBtn from '../components/CardBtn';

import Logo from '../components/Logo'

import { supabase } from '../supabaseClient'

import ActivityVideo from '../components/session/activities/ActivityVideo';
import ActivityGoogleForm from '../components/session/activities/ActivityGoogleForm';
import ActivityQuiz from '../components/session/activities/ActivityQuiz';
import ActivityAttendance from '../components/session/activities/ActivityAttendance';

import Navegation from '../components/Navegation'

import ActivitySkeleton from '../components/session/activities/ActivitySkeleton';

import * as maptilersdk from '@maptiler/sdk';
import "@maptiler/sdk/dist/maptiler-sdk.css";

export default function Sesion() {
    let { id } = useParams();
    const company = useCompany();

    const [loading, setLoading] = useState(true);

    const [session, setSession] = useState(null);
    const [materials, setMaterials] = useState(null);
    const [activities, setActivities] = useState([]);

    const map = useRef(null);
    const mapContainer = useRef(null);

    maptilersdk.config.apiKey = 'V8DFSo7qMSgAu0JLPgjH';


    const getSession = async () => {
        const { data, error } = await supabase
            .from('sessions')
            .select('*')
            .eq('id', id)
            .single();

        if (error) {
            return console.log(error);
        } else {
            console.log(data)
            setSession(data);
        }
    };

    const getMaterials = async () => {
        const { data, error } = await supabase
            .from('materials')
            .select('*')
            .eq('session', id)

        if (error) {
            return console.log(error);
        } else {
            console.log(data)
            setMaterials(data);
        }
    };

    const getActivities = async () => {
        const { data, error } = await supabase
            .from('activities')
            .select('*')
            .eq('session', id);

        if (error) {
            return console.log(error);
        } else {
            console.log(data);
            setActivities(data);
            setLoading(false);

        }
    };

    const renderActivity = (activity, session) => {

        const metadata = JSON.parse(activity.metadata)

        switch (activity.type) {
            case 'attendance':
                return <ActivityAttendance
                    activity={activity}
                    metadata={metadata}
                    session={session}
                />;
            case 'video':
                return <ActivityVideo
                    activity={activity}
                    metadata={metadata}
                    session={session}
                />;
            case 'quiz':
                return <ActivityQuiz
                    activity={activity}
                    metadata={metadata}
                    session={session}
                />;
            case 'googleForm':
                return <ActivityGoogleForm
                    activity={activity}
                    metadata={metadata}
                    session={session}
                />;
            default:
                return null;
        }
    };

    useEffect(() => {
        getSession();
        getMaterials();
        getActivities();
    }, []);

    useEffect(() => {
        if (map.current || !session) return;

        setTimeout(() => {
            if (!mapContainer.current) return;
            
            map.current = new maptilersdk.Map({
                container: mapContainer.current,
                style: maptilersdk.MapStyle.STREETS,
                center: [session?.long, session?.lat],
                zoom: 15
            });

            new maptilersdk.Marker({color: "#FF0000"})
                .setLngLat([session?.long, session?.lat])
                .addTo(map.current);
        }, 5000);
      
      }, [session?.long, session?.lat, mapContainer, map]);


    if (!company) {
        return <></>
    }
    console.log(session?.location)
    return (

        <ThemeClient>
            <Navbar title={session?.name} />

            <Logo
                style={{
                    height: 'auto',
                    maxWidth: '100%',
                    marginTop: '2rem',
                    marginBottom: '2rem',
                }}
            />

            <Container sx={{ marginTop: 2 }}>
                <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', color: 'white' }}>
                    <AttachFileIcon color='primary' sx={{ marginRight: 1 }} />
                    {company?.id === 45 ? 'Session Material' : 'Material de la sesión'}
                </Typography>
                {materials && materials.map((material, index) => (
                    <CardBtn url={material.url} text={material.title} key={material.title} icon={<InsertDriveFile />} />
                ))}

                {company?.demo && <CardBtn url={"https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"} text={"Material"} key={"material"} icon={<InsertDriveFile />} />}

                {!company?.simple_mode && (
                    <Activities>
                        <Grid container spacing={2}>

                            {company?.demo ? (
                                <>
                                    <Grid item xs={6}>
                                        <ActivityAttendance session={session} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <ActivityVideo session={session} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <ActivityQuiz session={session} />
                                    </Grid>
                                    {company?.id === 23 && (
                                        <Grid item xs={6}>
                                            <ActivityGoogleForm session={session} />
                                        </Grid>
                                    )}
                                </>
                            ) : (
                                <>

                                {activities.length === 0 ? (
                                        <>
                                        <Grid item xs={6}>
                                            <ActivitySkeleton />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <ActivitySkeleton />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <ActivitySkeleton />
                                        </Grid>
                                        </>
                                    ) : (
                                        activities.map((activity, index) => (
                                        <Grid item xs={6} key={index}>
                                            {renderActivity(activity, session)}
                                        </Grid>
                                        ))
                                    )}
                                </>
                            )}
                        </Grid>
                    </Activities>
                )}
                {/* <Feedback/> */}

                { session?.location != 'Online' && 
                <>
                <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', marginTop: 2, marginBottom: 1, color: 'white' }}>
                    <LocationOnIcon color='primary' sx={{ marginRight: 1 }} />
                    Ubicación
                </Typography>

                <Typography variant="h7" sx={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                    {session?.location}
                </Typography>
                
                <div className="map-wrap">
                    <div ref={mapContainer} className="map" />
                </div> 
                </>}

                {/* <iframe frameBorder={'none'} width="100%" height="300" src={`https://api.maptiler.com/maps/basic-v2/?key=V8DFSo7qMSgAu0JLPgjH#13.0/${session.lat}/${session.long}`}></iframe> */}
            </Container>
            <Navegation />
        </ThemeClient>
    );
}